/* eslint comma-spacing:0 */
const DimFields = [
  "ModalitiesInStudy",
  "PerformingPhysicianName",
  "StudyTime",
  "NumberOfStudyRelatedInstances",
  "StudyInstanceUID",
  "SeriesInstanceUID",
  "PatientSex",
  "StudyID",
  "PerformedLocation",
  "ManufacturerModelName",
  "Manufacturer",
  "PregnancyStatus",
  "SeriesNumber",
  "PatientBirthDate",
  "InstitutionName",
  "PatientAge",
  "AccessionNumber",
  "Priority",
  "StudyDescription",
  "ReferringPhysicianName",
  "OperatorName",
  "PatientID",
  "SeriesDescription",
  "Modality",
  "InstitutionDepartmentName",
  "StudyDate",
  "PatientTelephoneNumbers",
  "SOPInstanceUID",
  "PatientName",
  "SliceLocation"
];

export { DimFields };
